<div class="flex flex-col p-6 gap-5">
  <ep-breadcrumbs>
    <ep-breadcrumb [routerLink]="['/']"><span>Realm</span></ep-breadcrumb>
    <ep-breadcrumb><span>Clients</span></ep-breadcrumb>
  </ep-breadcrumbs>
  <div class="flex items-center justify-between">
    <h1>Clients</h1>
    <div class="flex gap-2">
      @if (canCreateNewClient()) {
        <ep-button [routerLink]="['/clients/create']" variant="primary"
          >Create or import Client</ep-button
        >
      }
      <ep-button (click)="refreshClients()" [disabled]="isLoading">
        <svg class="icon" viewBox="0 -960 960 960" fill="currentColor">
          <path
            d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"
          />
        </svg>
        <span>Refresh</span>
      </ep-button>
    </div>
  </div>

  <div class="flex justify-between items-center gap-4 mb-4">
    <div class="w-full max-w-md">
      <ep-textfield
        variant="search"
        [formControl]="searchControl"
        placeholder="Search by ClientId"
        class="flex-grow"
        ngDefaultControl
      >
        <ep-button
          slot="suffix"
          color="default"
          variant="quiet"
          size="tiny"
          (click)="clearSearch()"
        >
          <svg class="icon icon--small" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
            />
          </svg>
        </ep-button>
      </ep-textfield>
    </div>
  </div>

  <!-- Use a table instead of ep-items like in user list -->
  <table>
    <thead>
      <tr>
        <th class="text-left">Name</th>
        <th class="text-left">Description</th>
        <th class="text-left">Client ID</th>
        <th class="text-left">Protocol</th>
        <th class="text-left">Status</th>
      </tr>
    </thead>
    <tbody>
      @for (client of clients; track client.id) {
        <tr [routerLink]="[client.id]" class="cursor-pointer border-t border-stroke-subtle">
          <td class="body-sm font-medium">
            <div class="flex items-center gap-3">
              <div
                class="rounded icon icon--large bg-bg-primary-default text-fg-primary-bolder flex items-center justify-center"
              >
                <span class="icon__text">{{ client.name?.charAt(0) || '?' }}</span>
              </div>
              <span class="body-sm whitespace-nowrap">{{ client.name }}</span>
            </div>
          </td>

          <td>
            <span class="body-sm clamp-text clamp-text--one-line">{{ client.description }}</span>
          </td>
          <td class="body-sm whitespace-nowrap">{{ client.clientId }}</td>
          <td>
            <span class="body-sm whitespace-nowrap">{{ client.protocol }}</span>
          </td>
          <td class="flex items-center gap-2">
            @if (!client.enabled) {
              <ep-chip color="warning">Disabled</ep-chip>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>

  @if (isLoading) {
    <div class="py-6 flex justify-center items-center gap-3">
      <div class="lds-dual-ring !h-[1em] !w-[1em] text-[1.25rem]"></div>
      <span>Loading clients...</span>
    </div>
  }

  @if (!isLoading && clients.length === 0) {
    <div class="text-center py-6 text-gray-500">No clients found</div>
  }

  @if (!isLoading && clients.length > 0) {
    <div class="self-center mt-6">
      <ep-pagination
        type="simple"
        [currentPage]="currentPage"
        [totalPages]="totalPages()"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [totalItems]="totalClients"
        (change)="onPageChange($event)"
        (page-size-change)="onPageSizeChange($event)"
      >
      </ep-pagination>
    </div>
  }
</div>
